import { css } from '@compiled/react';

import { Stack } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

export const Header = ({ header, subheader }: { header: string; subheader?: string }) => {
	return (
		<Stack>
			<h1 css={headerCss}>{header}</h1>
			{subheader && <p css={subheaderCss}>{subheader}</p>}
		</Stack>
	);
};

const headerCss = css({
	fontSize: token('font.family.brand.heading', '28px'),
	fontWeight: token('font.weight.bold', '700'),
	margin: token('space.0', '0'),
});

const subheaderCss = css({
	marginBlockStart: token('space.100', '8px'),
	marginBlockEnd: token('space.300', '24px'),
	marginInlineStart: token('space.0', '0'),
	marginInlineEnd: token('space.0', '0'),
	font: token(
		'font.body',
		'14px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
	),
	color: token('color.text.subtle', '#6B778C'),
});
